/**
 * 调试客户端面板模块。
 */

import type { ChangeEvent } from "react";
import { useEffect, useState } from "react";
import { ConnectionManager } from "@/components/remote/debugger/connection-manager";
import { RoomSection } from "@/components/remote/debugger/room-section";
import { SignalSection } from "@/components/remote/debugger/signal-section";
import { checkDevice } from "@/services/remote/signaling";
import { socket, useSocketStore } from "@/services/remote/socket";
import { useConnectionStore } from "@/stores/remote";

/**
 * 远程客户端调试控制台。
 */
export default function Index() {
	const [deviceId, setDeviceId] = useState("AABBCC");
	const [accessCode, setAccessCode] = useState("123456");
	const { isConnected } = useSocketStore();
	const {
		currentRoomId,
		setCurrentRoomId,
		setSocket,
		startHeartbeat,
		stopHeartbeat,
	} = useConnectionStore();

	// 初始化 socket
	useEffect(() => {
		setSocket(socket);
	}, [setSocket]);

	// 当房间 ID 改变时，启动或停止心跳
	useEffect(() => {
		if (currentRoomId) {
			console.log("start heartbeat");
			startHeartbeat();
		} else {
			console.log("stop heartbeat");
			stopHeartbeat();
		}
	}, [currentRoomId, startHeartbeat, stopHeartbeat]);

	useEffect(() => {
		socket.on("join-room-success", (data: { roomId: string }) => {
			console.log("Successfully joined room with data:", data);
			// 在确认加入成功后发送测试消息
			setTimeout(() => {
				console.log("Sending test message to room:", data.roomId);
				socket.emit("room-message", {
					room: data.roomId,
					message: "test message",
				});
			}, 1000);
		});

		socket.on("join-room-error", (error: unknown) => {
			console.error("Failed to join room:", error);
		});

		// socket.on("room-message", ({ room, message, from }) => {
		//   console.log("client got message from room:", room, message, from);
		// });

		return () => {
			socket.off("join-room-success");
			socket.off("join-room-error");

			// socket.off("room-message");
			socket.off("join-room");
		};
	}, []);

	const handleDeviceIdChange = (event: ChangeEvent<HTMLInputElement>) => {
		setDeviceId(event.target.value);
	};

	const handleAccessCodeChange = (event: ChangeEvent<HTMLInputElement>) => {
		setAccessCode(event.target.value);
	};

	return (
		<div className="mt-10">
			<div className="py-2 flex flex-col w-full max-w-screen-xl items-center gaps-2 justify-between mx-auto">
				<ConnectionManager isConnected={isConnected} />
				<div className="divider">Connector</div>
				<div className="flex gap-2 w-full flex-wrap">
					<input
						placeholder="ID"
						name="deviceId"
						className="input input-bordered input-sm"
						value={deviceId}
						onChange={handleDeviceIdChange}
					/>
					<input
						placeholder="Access Code"
						name="accessCode"
						className="input input-bordered input-sm"
						value={accessCode}
						onChange={handleAccessCodeChange}
					/>
					<button
						type="button"
						className="btn btn-sm btn-default"
						onClick={async () => {
							try {
								const response = await checkDevice(deviceId, accessCode);
								const roomId = response?.roomId as string | undefined;
								if (roomId) {
									setCurrentRoomId(roomId);
									socket.emit("join-room", roomId);
								}
							} catch (error) {
								console.error("Check device failed:", error);
							}
						}}
					>
						Check Device Status
					</button>
				</div>
				<div className="divider">Rooms</div>
				<RoomSection />
				<div className="divider">SIGNAL</div>
				<SignalSection />
				<div className="flex my-2 gap-4"></div>
			</div>
		</div>
	);
}
